import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CORE_SERVICES } from '@core/services.const';
import { NgxsModule } from '@ngxs/store';
import { TranslationModule } from '@core/translation/translation.module';
import { CORE_STATE_EFFECTS, CORE_STATE_HELPERS, CORE_STATES } from '@core/states/core.states';
import { HeaderComponent } from '@core/components/header/header.component';
import { PageNotFoundComponent } from '@core/components/page-not-found/page-not-found.component';
import { ConfirmDialogModule } from '@shared/components/confirm-dialog/confirm-dialog.module';
import { LetDirectiveModule } from '@shared/directives/let/let-directive.module';
import { NGXS_CONFIG } from './ngxs.config';
import { CORE_INTERCEPTORS } from './interceptors.const';

@NgModule({
  declarations: [PageNotFoundComponent, HeaderComponent],
  exports: [PageNotFoundComponent, HeaderComponent, TranslationModule],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    NgxsModule.forRoot(CORE_STATES, NGXS_CONFIG),
    RouterModule,
    MatButtonModule,
    LetDirectiveModule,
    ConfirmDialogModule,
    TranslationModule,
  ],
  providers: [
    ...CORE_SERVICES,
    ...CORE_STATE_EFFECTS,
    ...CORE_STATE_HELPERS,
    ...CORE_INTERCEPTORS,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
